import React, { useState } from 'react';
import { motion } from 'framer-motion';

const Contact: React.FC = () => {
  const whatsappNumber = '917896353325';
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    details: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    const nextValue = name === 'phone' ? value.replace(/\D/g, '').slice(0, 10) : value;

    setFormData({
      ...formData,
      [name]: nextValue
    });
    setError('');
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim());
    const phoneValid = /^[6-9]\d{9}$/.test(formData.phone);

    if (!emailValid) {
      setError('Please enter a valid email address.');
      return;
    }

    if (!phoneValid) {
      setError('Please enter a valid 10 digit Indian phone number.');
      return;
    }

    const message = [
      'New project enquiry from Wevatar website',
      `Name: ${formData.name.trim()}`,
      `Email: ${formData.email.trim()}`,
      `Phone: +91 ${formData.phone}`,
      `Service: ${formData.service}`,
      `Details: ${formData.details.trim() || 'Not provided'}`
    ].join('\n');

    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.section id="contact" className="contact" initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
      <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
        Contact Us
      </motion.h2>
      <div className="contact-content">
        <form onSubmit={handleSubmit} className="contact-form" noValidate>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            inputMode="email"
            autoComplete="email"
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="10 digit Indian phone number"
            value={formData.phone}
            onChange={handleChange}
            inputMode="numeric"
            autoComplete="tel"
            pattern="[6-9][0-9]{9}"
            maxLength={10}
            required
          />
          <select
            name="service"
            value={formData.service}
            onChange={handleChange}
            required
          >
            <option value="">Select Service</option>
            <option value="website">Custom Website</option>
            <option value="webapp">Web Application</option>
            <option value="ecommerce">E-commerce</option>
            <option value="php">PHP Development</option>
            <option value="maintenance">Maintenance</option>
          </select>
          <textarea
            name="details"
            placeholder="Project Details"
            value={formData.details}
            onChange={handleChange}
            rows={5}
          ></textarea>
          {error && <p className="form-error" role="alert">{error}</p>}
          <button type="submit" className="btn-primary">Send on WhatsApp</button>
        </form>
        <div className="contact-info">
          <h3>Get In Touch</h3>
          <p><strong>Email:</strong> info@wevatar.com</p>
          <p><strong>Phone & WhatsApp:</strong> +91 7896353325</p>
          <p><strong>Location:</strong> Silchar, Assam, India</p>
        </div>
      </div>
    </motion.section>
  );
};

export default Contact;
